var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5002 162.057C128.677 162.057 162.057 128.677 162.057 87.4999C162.057 46.3231 128.677 12.9426 87.5002 12.9426C46.3233 12.9426 12.9429 46.3231 12.9429 87.4999C12.9429 128.677 46.3233 162.057 87.5002 162.057Z",
    fill: "#FBFBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5 5.27879e-06C70.1942 5.27879e-06 53.2769 5.13179 38.8876 14.7464C24.4983 24.361 13.2832 38.0267 6.66058 54.0152C0.0379124 70.0037 -1.69488 87.5971 1.68133 104.57C5.05753 121.544 13.3911 137.135 25.6282 149.372C37.8653 161.609 53.4563 169.943 70.4296 173.319C87.403 176.695 104.996 174.962 120.985 168.339C136.973 161.717 150.639 150.502 160.254 136.112C169.868 121.723 175 104.806 175 87.5C175.004 76.0082 172.743 64.6283 168.348 54.0105C163.952 43.3927 157.507 33.7452 149.381 25.6193C141.255 17.4933 131.607 11.0483 120.99 6.65241C110.372 2.25654 98.9918 -0.003987 87.5 5.27879e-06ZM87.5 25.0043C94.9151 25.0043 102.164 27.2032 108.329 31.3228C114.495 35.4424 119.3 41.2977 122.137 48.1484C124.975 54.999 125.718 62.5373 124.271 69.8099C122.824 77.0825 119.254 83.7628 114.01 89.006C108.767 94.2493 102.087 97.82 94.8142 99.2666C87.5416 100.713 80.0034 99.9708 73.1527 97.1331C66.3021 94.2955 60.4467 89.4901 56.3271 83.3247C52.2076 77.1593 50.0087 69.9107 50.0087 62.4957C50.0047 57.5711 50.9717 52.6941 52.8544 48.1436C54.7371 43.5932 57.4986 39.4586 60.9808 35.9764C64.463 32.4942 68.5975 29.7328 73.148 27.8501C77.6985 25.9674 82.5755 25.0003 87.5 25.0043ZM138.937 122.561C133.271 131.001 125.616 137.918 116.645 142.701C107.675 147.484 97.6657 149.985 87.5 149.985C77.3344 149.985 67.3249 147.484 58.3546 142.701C49.3843 137.918 41.7288 131.001 36.0634 122.561C34.4946 120.267 33.7275 117.519 33.8814 114.745C34.0352 111.97 35.1014 109.324 36.9141 107.218C50.1302 91.9661 68.4506 112.413 87.5 112.413C106.55 112.413 124.87 91.875 138.086 107.127C139.921 109.24 141 111.904 141.154 114.698C141.308 117.492 140.528 120.259 138.937 122.561Z",
    fill: "url(#paint0_linear_701_818)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_701_818",
    x1: 0,
    y1: 0,
    x2: 51.4706,
    y2: 205.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADE90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/defaultProfile.80df813269711f15df8bc7ca48bdb5d9.svg";
export { ForwardRef as ReactComponent };